import { useEffect } from "react";

const ATTR = "data-scroll-locked";
const SCROLL_Y = "data-scroll-y";

function scrollParents() {
  return document.querySelectorAll<HTMLElement>(
    "#main-content, [data-board-scroll]",
  );
}

/**
 * Lock document / nested board scroll while a board overlay is open.
 * Ref-counted so nested dialogs restore only when the last one closes.
 */
export function lockPageScroll() {
  const html = document.documentElement;
  const body = document.body;
  const extras = scrollParents();
  const count = Number(body.getAttribute(ATTR) || 0);
  const scrollY = window.scrollY;

  if (count === 0) {
    body.setAttribute(SCROLL_Y, String(scrollY));
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${scrollY}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    extras.forEach((el) => {
      el.dataset.prevOverflow = el.style.overflow;
      el.style.overflow = "hidden";
    });
  }
  body.setAttribute(ATTR, String(count + 1));

  return () => {
    const next = Number(body.getAttribute(ATTR) || 1) - 1;
    if (next > 0) {
      body.setAttribute(ATTR, String(next));
      return;
    }
    const y = Number(body.getAttribute(SCROLL_Y) || 0);
    html.style.overflow = "";
    body.style.overflow = "";
    body.style.position = "";
    body.style.top = "";
    body.style.left = "";
    body.style.right = "";
    body.style.width = "";
    body.removeAttribute(ATTR);
    body.removeAttribute(SCROLL_Y);
    extras.forEach((el) => {
      el.style.overflow = el.dataset.prevOverflow ?? "";
      delete el.dataset.prevOverflow;
    });
    window.scrollTo(0, y);
  };
}

export function useOverlayScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    return lockPageScroll();
  }, [active]);
}
